import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
`;

interface Props {
  className?: string;
}
export const StopClickEventPropagation: FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  return (
    <Wrapper className={className} onClick={(event) => event.stopPropagation()}>
      {children}
    </Wrapper>
  );
};
